import { GET_CONFIGS, GET_CONFIGS_SUCCESS, GET_CONFIGS_ERROR } from "./actionTypes";

const initialState = {
  shortcodes: [],
  error: "",
  success: "",
};

const config = (state = initialState, action) => {
  switch (action.type) {
    case GET_CONFIGS_SUCCESS:
      state = { ...state, shortcodes: action.payload };
      break;
    case GET_CONFIGS_ERROR:
      state = { ...state, error: action.payload, shortcodes: [] };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default config;
